<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "deciceClass",
      key: "id",
      url: {
        get: "/admin/system/facilityType",
        add: "/admin/system/facilityType",
        edit: "/admin/system/facilityType",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "资产分类",
          name: "facilityName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "分类编号",
          name: "sigillum",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        // {
        //   label: "是否可抄张类型",
        //   name: "needMeterReading",
        //   value: 0,
        //   type: "switch",
        //   trueValue: 1,
        //   falseValue: 0,
        //   width: "400px",
        // },
        {
          label: "国标基础分类",
          name: "basicClassification",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "分类代码",
          name: "classificationCode",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "textarea",
          width: "400px",
        },
      ],
      forms: {},
    };
  },
  created() {},
  methods: {},
};
</script>
